import { gql } from '@apollo/client'

import { CUISINE_TYPE_NODE_FRAGMENT } from '../fragments'

const SET_IS_CURATION_ENABLED_CUISINE_TYPE_MUTATION = gql`
  mutation setIsCurationEnabledCuisineType(
    $id: ID!
    $isCurationEnabled: Boolean!
  ) {
    setIsCurationEnabledCuisineType(
      id: $id
      isCurationEnabled: $isCurationEnabled
    ) {
      ...CuisineTypeNodeFragment
    }
  }
  ${CUISINE_TYPE_NODE_FRAGMENT}
`

export default SET_IS_CURATION_ENABLED_CUISINE_TYPE_MUTATION
